import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import FrontLoader from '../layout/FrontLoader';
import { getFromStorage } from '../../utils/Helper';
import { StorageConstant } from '../../constants/Constants';
import { LanguageConstants } from '../../constants/LanguageConstants';
import LandingMarketingNav from '../home/LandingMarketingNav';
import Footer from '../home/Footer';
import '../home/landing.scss';
import './Cms.scss';

function mergeCmsContentToSingleParagraph(html: string): string {
  const trimmed = String(html ?? '').trim();
  if (!trimmed) return '';

  const doc = new DOMParser().parseFromString(trimmed, 'text/html');
  const paragraphs = Array.from(doc.body.querySelectorAll('p'));
  const parts = (paragraphs.length ? paragraphs : [doc.body])
    .map((node) => (node instanceof HTMLParagraphElement ? node.innerHTML : node.textContent)?.trim() || '')
    .filter(Boolean);

  return parts.join('<br /><br />');
}

function Cms() {
  const { id } = useParams();
  const cmsRequest = useMakeRequest();
  const { pathname } = useLocation();
  const [data, setData] = useState<any>({});
  const lang = getFromStorage({ key: 'Translate' });
  const hasAccessToken = Boolean(getFromStorage({ key: StorageConstant?.ACCESS_TOKEN }));

  const slug = useMemo(() => pathname.split('/').filter(Boolean).pop() || '', [pathname]);
  const isAboutUs = slug === 'about-us';

  useEffect(() => {
    cmsRequest.makeRequest({
      payload: {
        slug,
        user_type: 1,
        lang_id: lang === 'spa' ? '2' : '1',
      },
      url: ApiConstants?.Cms,
      toastStatus: false,
    });
  }, [id, slug, lang]);

  useEffect(() => {
    if (cmsRequest?.status) {
      setData(cmsRequest?.data?.data);
    }
  }, [cmsRequest?.status]);

  const pageTitle = data?.cms_pages_details?.title?.trim() || LanguageConstants?.ABOUTUS;
  const pageContent = data?.cms_pages_details?.content;
  const hasPageContent = Boolean(String(pageContent ?? '').trim());
  const aboutUsParagraphHtml = useMemo(
    () => (isAboutUs && hasPageContent ? mergeCmsContentToSingleParagraph(pageContent) : ''),
    [isAboutUs, hasPageContent, pageContent]
  );

  const heading = isAboutUs
    ? (LanguageConstants?.LANDING_ABOUT_LABEL ?? pageTitle)
    : pageTitle;

  return (
    <div className={`landing-page cms-page${hasAccessToken ? ' landing-page--app-header' : ''}`}>
      {!hasAccessToken ? <LandingMarketingNav activeNav={isAboutUs ? 'about' : null} /> : null}
      {cmsRequest?.loading ? <FrontLoader /> : null}

      <main>
        <section className="landing-section landing-about sec-y-space sec-bg w-100">
          <div className="container">
            <span className="sec-ttl mb-4 text-capitalize">{heading}</span>

            <div
              className={`landing-about__body landing-about__body--full${
                isAboutUs ? '' : ' cms-page__prose'
              }`}
            >
              {isAboutUs ? (
                aboutUsParagraphHtml ? (
                  <p dangerouslySetInnerHTML={{ __html: aboutUsParagraphHtml }} />
                ) : null
              ) : hasPageContent ? (
                <div dangerouslySetInnerHTML={{ __html: pageContent }} />
              ) : null}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Cms;
